// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"a6c44f5d","241":"c02dd908","266":"b641f1dc","719":"ee1181e4","868":"7a63a56e"}[chunkId] + ".chunk.js";
};